export function getRandomInt(total) {
    return Math.floor(Math.random() * total);
  }